import api from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i += 1) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

export function isIos() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}

export function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}

export function iosNeedsInstall() {
  return isIos() && !isStandalone();
}

export async function getExistingSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function enablePush() {
  if (!pushSupported()) throw new Error("Push is not supported on this browser");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Notifications were blocked. Allow them in your browser settings.");
  const { data } = await api.get("/push/vapid-public-key");
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.key),
    });
  }
  await api.post("/push/subscribe", { subscription: sub.toJSON() });
  return sub;
}

export async function disablePush() {
  const sub = await getExistingSubscription();
  if (sub) {
    try { await api.post("/push/unsubscribe", { endpoint: sub.endpoint }); } catch (e) { console.warn("push unsubscribe server cleanup failed", e); }
    await sub.unsubscribe();
  }
}

const AUTO_KEY = "kingly-push-auto-attempted";

export async function autoEnablePush() {
  if (!pushSupported()) return false;
  if (Notification.permission === "granted") {
    try {
      const sub = await getExistingSubscription();
      if (sub) {
        await api.post("/push/subscribe", { subscription: sub.toJSON() });
      } else {
        await enablePush();
      }
      return true;
    } catch (e) { console.warn("push auto-resubscribe failed", e); return false; }
  }
  if (Notification.permission !== "default") return false;
  if (!isStandalone()) return false;
  if (localStorage.getItem(AUTO_KEY)) return false;
  const attempt = async () => {
    localStorage.setItem(AUTO_KEY, "1");
    try { await enablePush(); } catch (e) { console.warn("push permission not granted", e); }
  };
  if (isIos()) {
    window.addEventListener("pointerdown", attempt, { once: true });
  } else {
    attempt();
  }
  return true;
}
